import { useQuery } from "react-query";

const fetchTestimonials = async () => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_REACT_APP_API_URL}/api/testimonials`
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  } catch (error) {
    console.log(error);
  }
};

export const useTestimonials = () => {
  const { data, isLoading } = useQuery({
    queryKey: [`testimonials`],
    queryFn: () => fetchTestimonials(),
  });

  return {
    data,
    isLoading,
  };
};
